import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { DataBox } from '../DataBox';
import { Icon } from '../Icon';
import { Link } from '../Link';

export const DocumentList = styled.ul.withConfig({ componentId: 'sc-1dofano-0' })`
    --_color: var(--c-text-main);
    --_gap: ${size(1)};
    --_column-count: 2;
    --_min-width: 300px;
    --_gap-count: calc(var(--_column-count) - 1);
    --_total-gap-width: calc(var(--_gap-count) * var(--_gap));
    --_max-width: calc((100% - var(--_total-gap-width)) / var(--_column-count));

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(max(min(var(--_min-width), 100%), var(--_max-width)), 1fr));
    gap: var(--_gap);
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const DocumentListItem = styled(DataBox).attrs(() => ({
  as: 'li',
})).withConfig({ componentId: 'sc-1dofano-1' })`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${size(2)};
`;

export const DocumentListTitle = styled(Link).attrs(() => ({
  $noExternalIcon: true,
  $hoverGhost: true,
  $currentColor: true,
})).withConfig({ componentId: 'sc-1dofano-2' })`
    font-weight: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DocumentListFormat = styled.div.withConfig({ componentId: 'sc-1dofano-3' })`
    display: flex;
    align-items: center;
    gap: ${size(1)};
    color: var(--c-text-muted);
    text-transform: uppercase;

    ${Icon} {
        font-size: ${size(2.5)};
        color: var(--_color);
    }
`;
